import { createSlice } from "@reduxjs/toolkit";

const responsibleHandleSlice = createSlice({
  name: "responsiveHandle",
  initialState: {
    showSideBar: true,
    showConversation: false,
  },
  reducers: {
    toggleSidebar: (state) => {
      state.showSideBar = !state.showSideBar;
    },
    toogleConversation: (state) => {
      state.showConversation = !state.showConversation;
    },
  },
});

export const { toggleSidebar, toogleConversation } =
  responsibleHandleSlice.actions;
export default responsibleHandleSlice.reducer;
